import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { BASE_PATH } from "./constants";
import { ServiceManager } from "./service/service-manager";

import "./app.scss";
import { LoginPage } from "./container/login-page";
import { RegisterPage } from "./container/register-page";

function comp(Comp: any, options: any) {
    return class extends React.Component {
        render() {
            return <Comp {...this.props} {...options} />;
        }
    };
}

export class App extends React.Component {
    serviceManager: ServiceManager;
    pages: {
        login: any,
        register: any,
        resetpassword: any
    };
    constructor() {
        super();
        this.serviceManager = new ServiceManager(window.fetch.bind(window), {
            basepath: BASE_PATH
        });
        this.pages = {
            login: comp(LoginPage, { serviceManager: this.serviceManager }),
            register: comp(RegisterPage, {
                serviceManager: this.serviceManager
            })
        };
    }
    render = () => {
        return (
            <Router basename={BASE_PATH}>
                <div
                    id="max-identity-application"
                    className="max-identity-application trs-online-styles"
                >
                    <Switch>
                        <Route path="/login" component={this.pages.login} />
                        <Route
                            path="/password/recover"
                            component={this.pages.login}
                        />
                        <Route
                            path="/password/reset"
                            component={this.pages.login}
                        />
                        <Route
                            path="/register"
                            component={this.pages.register}
                        />
                        <Route
                            render={() => {
                                window.location.href = `${BASE_PATH}/login`;
                            }}
                        />
                    </Switch>
                </div>
            </Router>
        );
    };
}
